import { render, staticRenderFns } from "./VehiculeManagement.vue?vue&type=template&id=2d644262&"
import script from "./VehiculeManagement.vue?vue&type=script&lang=js&"
export * from "./VehiculeManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports